var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"the-header"},[_c('img',{attrs:{"src":this.$projectPath + '/image/robot.png'}}),(!_vm.PageTitle)?_c('span',{staticClass:"title"},[_c('span',{staticClass:"bigger"},[_vm._v(_vm._s(_vm.LogoName[0]))]),_vm._v(_vm._s(_vm.LogoName[1])+" ")]):_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.PageTitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }